
import { Component, Mixins } from "vue-property-decorator";
import { instanceOfIPaintable, IDrawableItem } from "../../../../../domain/document/items";
import { BorderStyle, PaintStyle, Color, TextureKinds } from "../../../../../domain/drawing";
import { IObjectStyleReadable } from "../../IObjectStyleReadable";

@Component({
})
export default class StyledDrawableMixin extends Mixins() {
  shouldDrawEditStyle: boolean;
  editingSource: IDrawableItem;
  editStyleReader: IObjectStyleReadable;  // 実装するObject側に用意.
  shouldInputFreeAll: boolean;            // フリー入力対象の場合は定義されている.
  shouldDrawTransparentAll: boolean;

  get borderStyle(): BorderStyle {
    return this.editStyleReader
      ? this.editStyleReader.readBorderStyle(this.editingSource, !!this.shouldInputFreeAll)
      : new BorderStyle(new Color("transparent"));
  }

  get borderStyleProperties() {
    const isVisible = (this.borderStyle && (0 < this.borderStyle.width));
    return {
      outlineStyle: isVisible
        ? "solid"
        : "none",
      outlineColor: isVisible
        ? this.borderStyle.color.value
        : "transparent",
      outlineWidth: isVisible
        ? this.borderStyle.width + "px"
        : "0px",
    };
  }

  get paintStyle(): PaintStyle {
    if (instanceOfIPaintable(this.editingSource) && this.editStyleReader) {
      if (this.shouldDrawTransparentAll) {
        return new PaintStyle(new Color("transparent"));
      }
      if (this.shouldDrawEditStyle) {
        return this.editStyleReader.readPaintStyle(this.editingSource, !!this.shouldInputFreeAll);
      }
      return this.editingSource.paintStyle;
    }
    return new PaintStyle(new Color("transparent"));
  }

  get paintStyleProperties() {
    return {
      backgroundColor: (!this.paintStyle || (this.paintStyle.kind === TextureKinds.None) || !this.paintStyle.color)
        ? "transparent"
        : this.paintStyle.color.value,
    };
  }
}
